// extracted by mini-css-extract-plugin
export default {"root":"footer-module--root--yWMb-","copyright":"footer-module--copyright--sQRoO"};